import { render } from "./Gantts.vue?vue&type=template&id=a6fd944a"
import script from "./Gantts.vue?vue&type=script&lang=js"
export * from "./Gantts.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Gantts.vue?vue&type=style&index=0&id=a6fd944a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script